import type { FC } from 'react'
import { useState } from 'react'

import { Input } from '@skytech/ui'
import { useQuery } from '@tanstack/react-query'

import { Translation } from '@/app/translations/Translation'
import DepartmentList from '@/components/department/DepartmentList'
import { commonQueries } from '@/resources/queries'
import { commonSubscriptionResources } from '@/resources/subscriptions'

import { useNewSubscriptionContext } from './NewSubscriptionForm.context'

export const NewSubscriptionDepartments: FC = () => {
  const [searchQuery, setSearchQuery] = useState<string | null>(null)

  const { data: setup } = useQuery(
    commonQueries.subscriptionSetup(),
    commonSubscriptionResources.getSetup
  )
  const [companyId] = useNewSubscriptionContext().companyId
  const [departmentId, setDepartmentId] = useNewSubscriptionContext().departmentId

  const departmentsFilteredBySelectedCompany = setup?.departments.filter(
    dep => dep.customerId === companyId
  )

  return (
    <div className="new-subscription-user">
      <h3>
        <Translation id="Department" />
      </h3>

      <div className="config">
        <Input
          id="department-search"
          type="text"
          onChange={e => setSearchQuery(e.target.value)}
          placeholder="Search"
        />

        <DepartmentList
          isSingleChoiceList
          searchQuery={searchQuery}
          selectedDepartmentIds={departmentId ? [departmentId] : null}
          departmentList={departmentsFilteredBySelectedCompany || []}
          onDepartmentSelect={id => setDepartmentId(id)}
        />
      </div>
    </div>
  )
}
